import { fetcher } from '../../utility/domUtils';

export const SET_MANAGE_PAGE_INSIGHTS = 'SET_MANAGE_PAGE_INSIGHTS';

export function getDonationInsights(timeFrame) {
  const params = {};
  if (timeFrame && typeof timeFrame === 'string') {
    params.days_data = timeFrame;
  } else if (timeFrame) {
    params.start_date = timeFrame?.startDate;
    params.end_date = timeFrame?.endDate;
  }

  return (dispatch, getState) => {
    let resParams = {};
    return fetcher(
      `/donate/api/insights/products?` + new URLSearchParams(params),
      {
        method: 'GET',
      }
    )
      .then((response) => {
        resParams = {
          ...resParams,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          return {
            ...responseJson?.error,
            ...resParams,
          };
        }

        const {
          hostedProductsInsightsList = [],
          allProductsTotalAmount = 0,
          hostedProductsTotalAmount = 0,
          unhostedProductsTotalAmount = 0,
          formattedDonationAmounts = {},
          hasMultiCurrency = false,
        } = responseJson?.donationInsights ?? {};

        dispatch({
          type: SET_MANAGE_PAGE_INSIGHTS,
          payload: {
            insightsSummary: {
              allProductsTotalAmount,
              hostedProductsTotalAmount,
              unhostedProductsTotalAmount,
              formattedDonationAmounts,
              hasMultiCurrency,
            },
            hostedProductsInsights: {
              hostedProductsInsightsList,
              hasMultiCurrency,
            },
          },
        });

        return {
          primaryCurrency: responseJson?.data?.userPrimaryCurrency,
          ok: resParams.ok,
        };
      })
      .catch((error) => {
        return error;
      });
  };
}
